<template>
  <div class="sc-message--emoji">
    <EmojiText :text="data.emoji" />
  </div>
</template>

<script>
import EmojiText from '@/components/EmojiText'

export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  components: {
    EmojiText
  }
}
</script>

<style scoped>
.sc-message--emoji {
  font-size: 3em;
  font-family: color-emoji;
}
</style>
